const question = {
    yes: { resolvedProfile: 'D' },
    no: {},
};

export default question;
